import moment from "moment";
import { useEffect, useState } from "react";
import ReferenceRewardPopup from "./ReferenceRewardPopup";
import ReferenceInviteBonusPopup from "./ReferenceInviteBonusPopup";
import ReactDOM from "react-dom";
import SlotTournamentDetail from "./SlotTournamentDetail";
import FirstDepositDetail from "./FirstDepositDetail";
import PlatformIntroductionDetail from "./PlatformIntroductionDetail";
import PartnerRewardsDetail from "./PartnerRewardsDetail";
import DailyLossDetail from "./DailyLossDetail";
import SaturdayMysteryDetail from "./SaturdayMysteryDetail";
import DailyDepositDetail from "./DailyDepositDetail";
import GoldenEggDetail from "./GoldenEggDetail";
import RebateDetail from "./RebateDetail";
import AppRewardsDetail from "./AppRewardsDetail";
import TelegramRewardsDetail from "./TelegramRewardsDetail";
import RedPacketDetail from "./RedPacketDetail";
import LuckySpinDetail from "./LuckySpinDetail";
import VipBenefitsDetail from "./VipBenefitsDetail";
import InviteFriendsDetail from "./InviteFriendsDetail";
import WeeklyDepositDetail from "./WeeklyDepositDetail";
import MonthlyInviteDetail from "./MonthlyInviteDetail";
import DailyBettingMilestonesDetail from "./DailyBettingMilestonesDetail";
import DelayedTransactionDetail from "./DelayedTransactionDetail";
import DepositInstructionsDetail from "./DepositInstructionsDetail";
import WarpDownloadDetail from "./WarpDownloadDetail";

const PromotionDetail = ({ setActive, active }) => {
  const [rewardsOpen, setRewardsOpen] = useState(false);
  const [inviteOpen, setInviteOpen] = useState(false);
  const closeRewards = (reason) => {
    setRewardsOpen(false);
    if (reason !== "deposit") setInviteOpen(true);
  };
  useEffect(() => { const close = (event) => { if (event.key === "Escape" && !rewardsOpen && !inviteOpen) setActive(false); }; document.addEventListener("keydown", close); return () => document.removeEventListener("keydown", close); }, [setActive, rewardsOpen, inviteOpen]);
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return "Ended";
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `End in ${days} days ${hours} hours`;
  }

  const firstDeposit = /FIRST DEPOSIT BONUS/i.test(active?.title || "");
  const platformIntroduction = active?.title === "Platform Introduction";
  const slotTournament = active?.title === "JL Slot Ranking Tournament";
  const partnerRewards = active?.title === "Rewards for partners";
  const dailyLoss = active?.title === "Daily P&L Bonus";
  const saturdayMystery = active?.title === "Saturday Mystery Jackpot";
  const dailyDeposit = active?.title === "Receive a 20% bonus on your first deposit of the day.";
  const goldenEgg = active?.title === "Daily Golden Egg Bonus Win up to ৳888,888";
  const rebate = active?.title === "Real-time rebates of up to 3.0%";
  const appRewards = active?.title === "Download the app and get rewards.";
  const telegramRewards = active?.title === "Join Telegram to win prizes.";
  const redPackets = active?.title === "You can claim 12 free red envelopes every day.";
  const luckySpin = active?.title === "Lucky Spin – Win Prizes";
  const vipBenefits = active?.title === "VIP Member Benefits";
  const inviteFriends = /Invite friends to get\s+৳388/.test(active?.title || "");
  const weeklyDeposit = active?.title === "Weekly deposits, red envelope rewards.";
  const monthlyInvite = active?.title === "Invite good fortune and earn ৳1,000,000 a month.";
  const dailyMilestones = active?.title === "Daily Betting Milestones";
  const delayedTransaction = active?.title === "Bonus for Deposit/Withdrawal Delays";
  const depositInstructions = active?.title === "Deposit Instructions";
  const warpDownload = active?.title === "Download the 1.1.1.1 app";
  const showLongTerm = warpDownload || depositInstructions || delayedTransaction || dailyMilestones || monthlyInvite || weeklyDeposit || inviteFriends || firstDeposit || platformIntroduction || slotTournament || partnerRewards || dailyLoss || saturdayMystery || dailyDeposit || goldenEgg || rebate || appRewards || telegramRewards || redPackets || luckySpin || vipBenefits;
  return ReactDOM.createPortal(
    <div
      data-v-0b1870f8
      aria-expanded="true"
      data-modal="promo-details"
      className="v--modal-overlay"
      onMouseDown={(event) => { if (!rewardsOpen && !inviteOpen && !event.target.closest(".tcg_modal_wrap")) setActive(false); }}
    >
      {rewardsOpen && <ReferenceRewardPopup initialTab={/Download the app/i.test(active?.title || "") ? 1 : 0} onClose={closeRewards} />}
      {inviteOpen && <ReferenceInviteBonusPopup onClose={() => setInviteOpen(false)} />}
      <div className="v--modal-background-click">
        <div className="v--modal-top-right" />{" "}
        <div
          role="dialog"
          aria-modal="true"
          className="v--modal-box v--modal"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100dvh",
          }}
        >
          <div className="reference-promotion-dialog-frame">
            <div
              style={{ width: "fit-content" }}
              data-v-0b1870f8
              className={`tcg_modal_wrap hasBg reference-slot-dialog${showLongTerm ? " reference-deposit-dialog" : ""}${platformIntroduction ? " reference-platform-dialog" : ""}${slotTournament ? " reference-slot-dialog" : ""}`}
            >
              <button type="button" aria-label="Close promotion" onClick={() => setActive(false)} data-v-0b1870f8 className="tcg_modal_close special">
                ×
              </button>{" "}
              <div data-v-0b1870f8 className="tcg_modal_body">
                <div className="reference-promotion-heading"><h2>{active?.title || active?.offerName || "Promotion"}</h2>{showLongTerm ? <><p className="reference-deposit-date">{depositInstructions ? "2026/09/12" : dailyLoss ? "2026/09/11" : "2023/04/30"} 21:30:00 - Long term</p><p className="reference-deposit-remain"><i aria-hidden="true" />Remaining Time: Long term</p></> : active?.endDate && <p>{getTimeDifferenceString(new Date(), active.endDate)}</p>}</div>
                {warpDownload ? <WarpDownloadDetail /> : depositInstructions ? <DepositInstructionsDetail /> : delayedTransaction ? <DelayedTransactionDetail /> : dailyMilestones ? <DailyBettingMilestonesDetail /> : monthlyInvite ? <MonthlyInviteDetail /> : weeklyDeposit ? <WeeklyDepositDetail /> : inviteFriends ? <InviteFriendsDetail /> : vipBenefits ? <VipBenefitsDetail /> : luckySpin ? <LuckySpinDetail /> : redPackets ? <RedPacketDetail /> : telegramRewards ? <TelegramRewardsDetail /> : appRewards ? <AppRewardsDetail /> : rebate ? <RebateDetail /> : goldenEgg ? <GoldenEggDetail /> : dailyDeposit ? <DailyDepositDetail /> : saturdayMystery ? <SaturdayMysteryDetail /> : dailyLoss ? <DailyLossDetail /> : partnerRewards ? <PartnerRewardsDetail /> : slotTournament ? <SlotTournamentDetail /> : platformIntroduction ? <PlatformIntroductionDetail /> : firstDeposit ? <FirstDepositDetail /> : <div className="promo-details">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-body">
                        <div className="promo-list">
                          <div className="list-item">
                            <img
                              src={active?.src || `${process.env.REACT_APP_API_BASE_URL}${active?.descriptionImage}`}
                              alt={active?.title || "Promotion"}
                              className="item-img"
                            />{" "}
                            {active?.src && /Golden Egg|Download the app/i.test(active?.title || "") && <button className="reference-rewards-claim" type="button" onClick={() => setRewardsOpen(true)}>View Rewards</button>}
                          </div>
                        </div>{" "}
                        {/* <div className="vhtml">
                          <p>
                            <img
                              alt={active?.title || "Promotion"}
                              src={active?.src || `${process.env.REACT_APP_API_BASE_URL}${active?.descriptionImage}`}
                              style={{ width: "50%" }}
                            />
                          </p>
                        </div> */}
                      </div>{" "}
                    </div>
                  </div>
                </div>}
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("overlay")
  );
};

export default PromotionDetail;
